module.exports = __webpack_public_path__ + "img/mobile-rental-assets-03.2f0ca179.png";